import { render, staticRenderFns } from "./NavLinkMenu.vue?vue&type=template&id=10845ac2&scoped=true&"
import script from "./NavLinkMenu.vue?vue&type=script&lang=js&"
export * from "./NavLinkMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10845ac2",
  null
  
)

export default component.exports